import { typographyStyle, Colors, Button, Flex } from '@revenuemarket/cds';
import { Dropdown, Radio, RadioChangeEvent, Typography } from 'antd';
import { CategoryTreeItem } from '~apis/categories';
import { GroupTreeItem } from '~apis/custom-label';
import { FlattenTreeResult } from '~components/ui/HorizontalTreeTable/Table';

interface Props {
  item: FlattenTreeResult<GroupTreeItem | CategoryTreeItem>;
  childrenTree: FlattenTreeResult<GroupTreeItem | CategoryTreeItem>[];
  onChange: (e: RadioChangeEvent) => void;
  removalType: string;
  treeSelectSection: React.ReactNode;
  label: string;
}

const RemoveTypeSelectStepContnet: React.FC<Props> = ({
  childrenTree,
  item,
  onChange,
  removalType,
  treeSelectSection,
  label,
}) => {
  const childrenLength = childrenTree.length;
  return (
    <Flex direction="column" gap={12}>
      <Typography.Text
        style={{
          ...typographyStyle['14_400'],
          color: Colors.gray800,
        }}
      >
        {`${item?.value?.name} ${label}에 소속된`}{' '}
        <Dropdown
          menu={{
            items: childrenTree.map((item) => {
              return {
                key: item.key,
                label: (
                  <span
                    style={{
                      paddingLeft: 16 * item.colIndex,
                    }}
                  >
                    {item.value?.name}
                  </span>
                ),
              };
            }),
          }}
        >
          <Button
            buttonType="weak"
            border
            style={{
              color: Colors.blue500,
              ...typographyStyle['14_400'],
            }}
          >
            {`${childrenLength}개의 ${label}`}
          </Button>
        </Dropdown>
        {`을 어떻게 처리할까요?`}
      </Typography.Text>
      <Radio.Group onChange={onChange} value={removalType}>
        <Radio
          value={'remove'}
          style={{
            marginBottom: 12,
          }}
        >
          <Typography.Text
            style={{
              color: Colors.gray700,
              ...typographyStyle['14_400'],
            }}
          >
            {`하위${label}도 같이 삭제하기`}
          </Typography.Text>
        </Radio>
        <Flex direction="column" gap={8}>
          <Radio value={'change-parent'}>
            {' '}
            <Typography.Text
              style={{
                color: Colors.gray700,
                ...typographyStyle['14_400'],
              }}
            >
              {`다른 ${label} 밑으로 옮기기`}
            </Typography.Text>
          </Radio>
          {treeSelectSection}
        </Flex>
      </Radio.Group>
    </Flex>
  );
};

export default RemoveTypeSelectStepContnet;
